import PublicLayout from '../components/PublicLayout.jsx';
import TestimonialSection from '../components/TestimonialSection.jsx';

export default function TestimonialPage() {
  return (
    <PublicLayout>
      <div className="h-24" />
      <TestimonialSection />
    </PublicLayout>
  );
}
